import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, Collapse, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'

export default function ThinkingLog({ thoughts, live }: { thoughts: string[]; live: boolean }) {
  const intl = useIntl()
  const [open, setOpen] = useState(live)
  const toggle = () => setOpen((v) => !v)

  return (
    <Box data-testid="ca-thinking-log" sx={{ mb: 1 }}>
      <Box
        role="button"
        tabIndex={0}
        aria-expanded={open}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle() }
        }}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          cursor: 'pointer',
          color: 'text.secondary',
          userSelect: 'none',
          mb: 0.5,
          '&:hover': { color: 'text.primary' },
        }}
      >
        <Typography variant="caption">
          {intl.formatMessage({ id: 'caChat.thread.thoughts.label' }, { count: thoughts.length })}
        </Typography>
        <ExpandMoreIcon
          fontSize="small"
          sx={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}
        />
      </Box>
      <Collapse in={open} timeout="auto">
        <Box sx={{ pl: 1.5, borderLeft: 2, borderColor: 'divider' }}>
          {thoughts.map((t, j) => (
            <Typography
              key={j}
              variant="caption"
              sx={{ display: 'block', whiteSpace: 'pre-wrap', color: 'text.secondary', mb: 0.75 }}
            >
              {t}
            </Typography>
          ))}
        </Box>
      </Collapse>
    </Box>
  )
}
